export default "__VITE_ASSET__CfkmLFPr__"